import React, {Component} from "react";
import ReactSVG from "react-svg";
import MomentDate from "../../MomentDate";
import EVENT_STATUS from "../../../constants/event_status";

class EventTimer extends Component {
	intervalId = 0;

	constructor(props) {
		super(props);
		this.prevTime = props.time;
		this.state = {time : props.time};
	}

	componentWillMount() {
		this.intervalId = setInterval(this.tick.bind(this), 1000);
	}

	componentWillUnmount() {
		clearInterval(this.intervalId);
	}

	componentWillReceiveProps(nextProps) {
		clearInterval(this.intervalId);
		console.log('receive props');

		if ( nextProps.time !== this.prevTime ) {
			this.intervalId = setInterval(this.tick.bind(this), 1000);
			this.prevTime = nextProps.time;
		}

		this.state = {time : nextProps.time};
	}

	tick() {
		const time = this.state.time + 1;
		this.setState({time});
	}

	render() {
		return (
			<div className="event__information-timer">
				<span className="sport-icon green">
					<ReactSVG path={require("../../../../assets/images/svg/timer.svg")}/>
				</span>
				<span>
					&nbsp;<MomentDate date={this.state.time} parseTimeFromSeconds={true}/>
				</span>
			</div>
		);
	}
}

export default EventTimer;


// WEBPACK FOOTER //
// ./src/app/components/EventById/Event/EventTimer.js